<app-frame
  [title]="'Internal Error'"
[showBack]="false"
>
  <!-- H1 -->
  <span  class="e174_22">Machine out of service. Please contact support.</span>
</app-frame>
